export default "__VITE_PUBLIC_ASSET__f2f5f279__"